import React, { useEffect } from 'react';
import { META_DESCRIPTION, META_PIXEL_ID, PAGE_TITLE } from './data/content';
import { bonusCovers, heroMockupUrl, offerMockupUrl, pageImages } from './data/images';
import { initMetaPixel } from './utils/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsBand } from './components/StatsBand';
import { BeforeAfter } from './components/BeforeAfter';
import { MeetingSelector } from './components/MeetingSelector';
import { LookInsideSection } from './components/LookInsideSection';
import { SolutionSection } from './components/SolutionSection';
import { LevelsBand } from './components/LevelsBand';
import { YearPlanSection } from './components/YearPlanSection';
import { MeetingsList } from './components/MeetingsList';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
const pixelNoscript = META_PIXEL_ID ? `<img height="1" width="1" style="display:none" alt="" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />` : '';
export function App() {
  useEffect(() => {
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = META_DESCRIPTION;
    initMetaPixel();
  }, []);
  return <div id="top" className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink antialiased" data-id="element-0" data-mp="3dirvuqnas99b">
      {pixelNoscript && <noscript dangerouslySetInnerHTML={{
      __html: pixelNoscript
    }} data-id="element-1" data-mp="sudmqizlo5ad" />}
      <TopBar data-id="element-2" data-mp="swqbbezv5dwe" />
      <main data-id="element-3" data-mp="36hv93iy4lzn">
        <Hero heroMockupUrl={heroMockupUrl} data-id="element-4" data-mp="3688rpx40wyp" />
        <StatsBand data-id="element-5" data-mp="34x2njg6zd4f" />
        <BeforeAfter data-id="element-6" data-mp="38ktuby5znfz" />
        <MeetingSelector data-id="element-7" data-mp="3ud1glcmeruc7" />
        <LookInsideSection pageImages={pageImages} data-id="element-8" data-mp="3ubrfeek9e61c" />
        <SolutionSection data-id="element-9" data-mp="3uf5hdlp0gd89" />
        <LevelsBand data-id="element-10" data-mp="d57hf8hvkslp" />
        <YearPlanSection data-id="element-11" data-mp="d3mmvivk99nu" />
        <MeetingsList data-id="element-12" data-mp="d3wcv6glvgtj" />
        <BonusesSection bonusCovers={bonusCovers} data-id="element-13" data-mp="d2bf77yzvhrg" />
        <OfferSection offerMockupUrl={offerMockupUrl} data-id="element-14" data-mp="86w6eufugc1w" />
        <GuaranteeSection data-id="element-15" data-mp="3gleaym6kt9gr" />
        <FaqSection data-id="element-16" data-mp="3gklce8hrtq9p" />
        <FinalCta data-id="element-17" data-mp="3glwd1zfx6hwl" />
      </main>
      <Footer data-id="element-18" data-mp="3gj1s86szuv2n" />
      <StickyCta data-id="element-19" data-mp="3bmjrdi0sbgvl" />
    </div>;
}